import { Component, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Community } from '@models/communities/community.model';
import { Form } from '@models/forms/form.model';
import { FormType } from '@models/forms/form.model';
import { ICommunityService } from '@tokens/injection.tokens';
import { Resident } from '@models/account/resident.model';
import { map } from 'lodash';

@Component({
  selector: 'app-resident-forms',
  templateUrl: './resident-forms.component.html',
  styles: [],
})
export class ResidentFormsComponent {
  communityService = inject(ICommunityService);
  community: Community = this.communityService.model ?? <Community>{};

  resident: Resident = this.route.snapshot.data.resident;

  forms = `/communities/${this.community.id}/residents/${this.resident.id}/form`;
  availables: Form[] = [];

  constructor(private route: ActivatedRoute) {
    this.availables = map(this.community.forms, f => {
      f.type = FormType.Default;
      return f;
    });
    if (
      this.community.corporation?.name?.toLowerCase()?.includes('brookdale')
    ) {
      this.availables = this.availables.filter(
        item => item.name !== 'Care Profile' && item.name !== 'Dining Profile'
      );
    }
    if (this.resident && this.resident.migForm) {
      this.resident.migForm.type = FormType.Mig;
      this.availables.push(this.resident.migForm);
    }
  }
}
